import { useContext } from 'react';
import TradeContext from '~/context/common/TradeContext';
import { useIsLoggedIn } from '~/context/common/UserContext';
import DiscountContext from '~/context/vdp/DiscountContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';

export default function useIsPriceLoading() {
  const { discounts } = useContext(DiscountContext);
  const { trades } = useContext(TradeContext);
  const { vehiclePricingInfo } = useContext(UserVehicleContext);
  const isLoggedIn = useIsLoggedIn();

  return (
    !discounts.isLoaded ||
    (isLoggedIn && !trades.isLoaded) ||
    !vehiclePricingInfo.isLoaded
  );
}
